<template>
    <v-navigation-drawer id="app-drawer" class="drawer" v-model="inputValue" app floating persistent mobile-breakpoint="991" width="260">
        <template class="fill-height" tag="div" column>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        <v-container>
                            <a href="/" target="_self" title="" class="g-logo g-logo-helium">
                                <v-img :src="require('@/assets/SONDA-azulynegro.png')" width="180" />                
                            </a>
                        </v-container>
                    </v-list-item-title>

                    <v-list-item-subtitle>
                        Workspace
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item v-show="isAuthenticated">
                <v-list-item-avatar>
                    <v-img :src="getImageFromCache"></v-img>
                </v-list-item-avatar>       
                    
                <v-list-item-title>{{username}}</v-list-item-title>             
            </v-list-item>            

            <v-divider></v-divider>

            <v-list v-show="isAuthenticated"  class="menu" dense nav>     
                <template v-for="(menu, i) in listOfMenus">
                    <v-list-group v-if="isGroup(menu)" :key="`menu-group${i}`" no-action >
                        <template v-slot:activator>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon>{{ menu.icon }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>{{ menu.text }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="(menu.subtext || '').length > 0" >{{menu.subtext}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <template v-for="(submenu, i) in menu.children">
                            <v-list-item v-if="!isGroup(submenu)" link :to="submenu.path" class="subitem" :key="`submenu${i}`">
                                <v-list-item-icon>
                                    <v-icon>{{ submenu.icon }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>{{ submenu.text }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="(submenu.subtext || '').length > 0" >{{submenu.subtext}}</v-list-item-subtitle>
                                </v-list-item-content>    
                            </v-list-item>

                            <v-list-group v-else :key="`subgroup${i}`" no-action sub-group>
                                <template v-slot:activator>
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon>{{ submenu.icon }}</v-icon>
                                        </v-list-item-icon>  

                                        <v-list-item-content>
                                            <v-list-item-title>{{ submenu.text }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="(submenu.subtext || '').length > 0" >{{submenu.subtext}}</v-list-item-subtitle>
                                        </v-list-item-content>                                            
                                    </v-list-item>
                                </template>   

                                <v-list-item v-for="(submenuitem, i) in submenu.children" :key="`subgroup-item${i}`"
                                    link :to="submenuitem.path" class="subitem">
                                    <v-list-item-icon>
                                        <v-icon>{{ submenuitem.icon }}</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>{{ submenuitem.text }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="(submenuitem.subtext || '').length > 0" >{{submenuitem.subtext}}</v-list-item-subtitle>
                                    </v-list-item-content>        
                                </v-list-item>
                            </v-list-group>        

                        </template>
                    </v-list-group>   

                    <v-list-item v-else :key="`menu-item${i}`" link :to="menu.path" >
                        <v-list-item-icon>
                            <v-icon>{{ menu.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>{{ menu.text }}</v-list-item-title>
                            <v-list-item-subtitle v-if="(menu.subtext || '').length > 0" >{{menu.subtext}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>                           
                </template>
            </v-list>
        </template>        
    </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import DateMixin from '@/mixin/date'
import FormMixin from '@/mixin/form'

import ResponsivenessMixin from '@/mixin/responsiveness'
import UserApi from '@/api/identityProvider/user'
import PaisApi from '@/api/workspace/corporativo/pais'
import Colaborador from '@/api/workspace/success-factors/colaborador.js'

import MenuConfig from '@/components/core/menu/config.json'

export default {
    mixins: [ ResponsivenessMixin, DateMixin, FormMixin ],  
    data: () => ({
        listOfMenus: [],
        responsive: false,
        debouncedGetUserInfo: null,
        avatar: null
    }),
    computed: {
        ...mapState("app", ["image", "color"]),
        inputValue: {
            get () {
                return this.$store.state.app.drawer
            },
            set (val) {
                this.setDrawer(val)
            }
        }, 
        username(){
            return this.$store.state.app.userName;
        },
        getImageFromCache(){
            let avatar = window.localStorage.getItem("avatar-foto");
            if(avatar == null) 
                avatar = this.avatar;

            return avatar;
        }             
    },
    async created(){
        this.debouncedGetUserInfo = this.$_.debounce(async () => await this.getUserInformation(), 1000);    
        
        this.$security.events.$on("authenticated", this.debouncedGetUserInfo);
        this.$events.$on("locale-has-changed", this.getUserMenu);        

        this.debouncedGetUserInfo();
    },
    beforeDestroy(){
        this.$security.events.$off("authenticated", this.getUserInformation);
        this.$events.$off("locale-has-changed", this.getUserMenu);

        this.debouncedGetUserInfo.cancel();
    },  
    methods: {
        ...mapMutations("app", ["setDrawer", "toggleDrawer", "setUserName", "setUser", "setUserCountry"]),
        isGroup(menu){
            if(!menu.path && (menu.children || []).length > 0) return true; 
            if((menu.path == undefined || menu.path == null) && (menu.children || []).length > 0) return true; 

            if(this.$_.trim(menu.path) == "" && (menu.children || []).length > 0) return true;  
            return false;
        },
        async getUserInformation(){
            if(!this.isAuthenticated) return;

            this.setLoaderText(this.$t("Common.checking-user-access"));
            this.setLoaderQueue(this.uniqueId);            

            const userId = await this.$security.getUserId();
            if(userId != null){
                const user = await UserApi.listById(userId);
                if(user.success) {
                    this.setUser(user.data);
                    this.setUserName(`${user.data.firstName} ${user.data.lastName}`);   

                    const country = await PaisApi.listarPorId(user.data.idCountry);
                    if(country.success && country.data != null) { 
                        this.setUserCountry(country.data);
                    }
           
                    this.getUserMenu();

                    let userGenderAndImage = await Colaborador.listarFoto(user.data.idUserSuccessFactors);
                    let photo = this.$_.maxBy(userGenderAndImage.data.foto, function(o) {
                        return o.height;
                    });

                    if(photo != null){
                        this.avatar = `data:image;base64,${photo.photo}`; 
                        window.localStorage.setItem("avatar-foto", this.avatar)
                    }
                    else if(userGenderAndImage.data.usuario.sexo == "M"){
                        this.avatar = require('@/assets/avatar-man.svg');
                    }
                    else{
                        this.avatar = require('@/assets/avatar-woman.svg');
                    }
                }                
            }
            
            this.unsetLoaderQueue(this.uniqueId);    
        },
        async getUserMenu(){
            if(!this.isAuthenticated) return;

            this.setLoaderText(this.$t("Common.checking-user-access"));
            this.setLoaderQueue(this.uniqueId);     

            const menu = await UserApi.listMenu();
            if(menu.success && menu.data != null){
                let listOfMenu = [];
                const getNode = (menuNode, dbNode) => {
                    for(let count = 0; count < dbNode.child.length; count++){
                        const uniqueCode = dbNode.child[count].uniqueCode.replace(/[.]/gi, "-");
                        let text = this.$t(`Core.Menu.${uniqueCode}`);

                        if(text.indexOf(uniqueCode) >= 0)
                            text = dbNode.child[count].description;

                        let subText = this.$t(`Core.Menu.${uniqueCode}-subtext`);
                        if(subText.indexOf(uniqueCode) >= 0)
                            subText = "";

                        let icon = MenuConfig[`${uniqueCode}-icon`];
                        let route = MenuConfig[`${uniqueCode}-route`];

                        menuNode.children.push(getNode({
                            uniqueCode: dbNode.child[count].uniqueCode,        
                            text: text,
                            path: route,
                            icon: icon,
                            subtext: subText, 
                            children: []                               
                        }, dbNode.child[count]));                                
                    }

                    return menuNode;
                };

                for(let count = 0; count < menu.data.length; count++){
                    const uniqueCode = menu.data[count].uniqueCode.replace(/[.]/gi, "-");
                    let text = this.$t(`Core.Menu.${uniqueCode}`);

                    if(text.indexOf(uniqueCode) >= 0)
                        text = menu.data[count].description;

                    let subText = this.$t(`Core.Menu.${uniqueCode}-subtext`);
                    if(subText.indexOf(uniqueCode) >= 0)
                        subText = "";

                    let icon = MenuConfig[`${uniqueCode}-icon`];
                    let route = MenuConfig[`${uniqueCode}-route`];                                

                    listOfMenu.push(getNode({
                        uniqueCode: menu.data[count].uniqueCode,        
                        text: text,
                        path: route,
                        icon: icon,                                
                        subtext: subText, 
                        children: []                               
                    }, menu.data[count]));
                }

                this.$set(this, "listOfMenus", listOfMenu);
            }    
            
            this.unsetLoaderQueue(this.uniqueId);    
        }              
    }
}
</script>

<style lang="scss" scoped> 
@import "../../styles/material-dashboard/variables";

</style>
